import { render, staticRenderFns } from "./EditSimpleUser.vue?vue&type=template&id=d4713ca0"
import script from "./EditSimpleUser.vue?vue&type=script&lang=ts"
export * from "./EditSimpleUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports